// ألوان أيقونات تبويبات صفحة الفرع — بنفس نمط بلاطات الرئيسية.
import { Building2, Calculator, Clock, CalendarDays, Receipt, Wallet, Plane, QrCode, Phone, Scale } from "lucide-react";

export const BRANCH_TAB_META = {
  basics:    { icon: Building2,   color: "bg-fuchsia-500" },
  accounting:{ icon: Calculator,  color: "bg-emerald-600" },
  shift:     { icon: Clock,       color: "bg-sky-500" },
  holidays:  { icon: CalendarDays,color: "bg-rose-500" },
  payroll:   { icon: Receipt,     color: "bg-lime-600" },
  advances:  { icon: Wallet,      color: "bg-amber-500" },
  leave:     { icon: Plane,       color: "bg-cyan-500" },
  qr:        { icon: QrCode,      color: "bg-indigo-500" },
  contact:   { icon: Phone,       color: "bg-teal-500" },
  legal:     { icon: Scale,       color: "bg-orange-500" },
};
